import { get } from 'helpers/api_helper';

export const fetchInvestments = async (payload) => {
  return await get(
    `user/deposit?take=${payload.take}&skip=${payload.skip}&order_by=${
      payload.sortField || 'date'
    }&order=${payload.sortOrder || 'DESC'}&locale=${payload.locale || 'en'}`,
  );
};

export const fetchInvestmentsSummary = async () => {
  return await get('user/deposit/investment-summary');
};

export const fetchInvestmentsAnalysis = async () => {
  return await get('user/deposit/investments-info');
};

export const fetchInvestmentsInfoLight = async () => {
  return await get('user/deposit/investments-info-light');
};

// Dashboard V2 «Ваши средства» (выписка-водопад). Бэкенд: GET user/deposit/investments-summary
export const fetchInvestmentsStatement = async () => {
  return await get('user/deposit/investments-summary');
};
